// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3P2d5","title":"Info_title__1rDtr","selects":"Info_selects__1ogGX","requiredAsterisk":"Info_requiredAsterisk__2Pkzg"};